import Lottie from 'lottie-react';

import pointLoading from '@/assets/lottieFiles/point-loading.json';

import {CardStatus} from '../interface';

import styles from './index.module.scss';

interface IProps {
    status: CardStatus;
}

const Error: React.FC<IProps> = ({status}) => {
    const loadingContent = <div className={styles.loading}>
        <span className={styles.text}>正在加载中</span>
        <Lottie className={styles.point} animationData={pointLoading} loop />
    </div>;
    const loadFailContent = <div className={styles.loadFail}>加载失败，请稍候再试</div>;
    const notFoundContent = <div className={styles.notFound}>该文档已被删除</div>;

    const content = status === CardStatus.Loading
        ? loadingContent
        : status === CardStatus.LoadFail
            ? loadFailContent
            : status === CardStatus.NotFound
                ? notFoundContent
                : null;

    return content;
};

export default Error;
